import React from 'react';
import Modal from "../Modal";
import { IconLoader } from "../../assets/images";

const Loader = (props = {}) => {

    const {
        type = "",
        imageLoader = true,
    } = props || {};
    return (
        <React.Fragment>
            {imageLoader ?
                <Modal>
                    <div className={`pageLoader ${type === "" ? "" : type}`}>
                        <i><IconLoader /></i>
                    </div>
                </Modal>
                :
                <Modal>
                    <div className="css_loader_spinner">
                        <div className="css_spinner_inner"><div></div></div></div>
                </Modal>
            }
        </React.Fragment>
    );
};
export default Loader;
